<template>
  <van-collapse v-model="activeNames" v-if="ht"  accordion>
    <van-collapse-item title="对应预算" name="1">
      <ys  :ht="ht.kYs" v-if="checkPermi(['xm:ys:list'])"></ys>
      </van-collapse-item>
      <van-collapse-item title="对应采购合同" name="2">
        <cght v-if="ht.cghtid && checkPermi(['xm:cght:list'])" :htid="ht.cghtid" ></cght>
        </van-collapse-item>
    <van-collapse-item title="核销详情" name="3">
      <van-cell title="收款单位" :label="ht.skdw"  />
       <van-cell title="开户行" :label="ht.skkhh"  />
        <van-cell title="银行账号" :label="ht.skyhzh"  />
      <van-cell v-if="xsht" title="已核销金额" :value="xsht.hxje"  />
      <van-cell title="本次核销金额" :value="ht.hxje"  />
      <van-cell v-if="xsht" title="已付款金额" :value="xsht.fkje"  />
      <van-cell title="本次付款金额" :value="ht.fkje"  />
      <!-- <van-cell v-if="ht.cght" title="所属部门" :value="U.chooseValueFromArr(depts,'deptId',ht.cght.deptid, 'deptName')"  /> -->

        <van-cell v-if="true" title="核销时间" :value="U.parseTime(ht.createTime,'{y}-{m}-{d}')"  />
       <van-cell title="申请人" :value="ht.sqrmz"  />

       <van-cell v-if="ht.hxfj" title="附加文件"  >
            <template #label>
              <Filedownload :srcs="ht.hxfj"></Filedownload>
            </template>
        </van-cell>
        <template  v-if="ht.kHxxqList">
            <van-divider>具体核销项目</van-divider>
          <van-cell :key="'hx'+hxx.id" v-for="hxx in ht.kHxxqList" :title="xzproduct(hxx.pid)"  >
               <template #label>
                 <span>核销金额:{{parseFloat(hxx.hxje || 0)*100}} | 支付金额:{{hxx.fkje || 0}}</span>
                 <span>税率:{{parseFloat(hxx.tax || 0)*100}}% | 进项税:{{hxx.ssje || 0}}</span>

               </template>
           </van-cell>
        </template>

    </van-collapse-item>

  </van-collapse>
</template>

<script>
import ys from './ys.vue'
import cght from './cght.vue'
import Filedownload from '../../components/FileDownload/index.vue'
export default {
  name: 'hx',
  components: {
    ys: ys,
    cght: cght,
    Filedownload: Filedownload
  },
  props: {
    id: {
      type: String,
      default: null
    },
    ht: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      activeNames: '3',
      dict: {type: []},
      dicts: ['xm_htjd', 'xm_hzxz', 'xm_yes_no', 'xm_htfjsx'],
      dataid: null,
      workid: null,
      products: [],
      dqlc: null,
      xsht: null,
      depts: [],
      shshow: false,
      loading: false,
      form: {
        dataid: null,
        shzt: 1,
        shyj: ''
      }

    }
  },
  created () {
    console.log('hx:', this.ht)
    this.getdepts()
    this.getdicts()

    this.getproducts()
    this.getHt()
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    xzproduct (pid) {
      return this.U.chooseValueFromArr(this.products, 'id', pid, 'mz')
    },

    getdepts () {
      let that = this
      this.$ajax.get('/system/dept/list').then(res => {
        that.depts = res.data
      })
    },
    getproducts () {
      let that = this
      this.$ajax.get('/xm/product/kylist').then(res => {
        that.products = res.data
      })
    },
    getdicts () {
      let that = this
      if (this.dicts.length > 0) {
        for (let d of this.dicts) {
          // console.log("d",d)
          this.$ajax.get('/system/dict/data/type/' + d).then(res => {
            that.dict.type[d] = res.data
            //  console.log(that.dict)
          })
        }
      }
    },
    getHt () {
      let that = this
      if (this.ht) return
      else {
        this.$ajax.get('/xm/hx/' + this.id).then(function (res) {
          if (res.code == 200) {
            that.ht = res.data
            if (res.data.kYs) {
              this.$ajax.get('xm/xshttz/' + res.data.kYs.xshtid).then(res2 => {
                that.xsht = res2.data
              })
            }
          }
        })
      }
    }

  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/Zsmb/hx.vue